module.exports = __webpack_public_path__ + "media/components/journeys/ticket-icons/orangePin-b7e19a55972cda9b68dd50c65a488ba8.png";